import { DeviceTypes } from "../../config/documents/HardwareConfig";
import { PoolDeviceInterface } from "../Interfaces";
import Locale from "../../utils/Locale";
import PoolDevice from "./base";

export default class PoolDeviceCleaner extends PoolDevice implements PoolDeviceInterface {
    static CanBeAddedToflow = true;
    static DeviceType = DeviceTypes.CLEANER;
    static Icon = "cleaner";
    static PickerTitle = Locale.gettext("Cleaner");
}
